import StockApi from './StockApi'
import {store} from './SecureLS'
import {ssoClient, stockClient} from './SigninSetup'

export const checkLoginByPass = async function () {
    let {data} = await StockApi.get('/check-bypass');

    return data
}

export const setLoginMode  = function (loginType = '') {
    if (!loginType) return
    store.set('shppr:stock:tl', btoa(loginType))
}
  
export const checkLoginMode = function () {
    const loginMode = store.get('shppr:stock:tl')

    if (!loginMode) {
        return ''
    }

    try {
        return atob(loginMode)
    } catch {
        return ''
    }
}

export const handleLoginMode = function (newLoginMode) {
    let actualLoginMode = checkLoginMode()

    if(actualLoginMode != newLoginMode) {
        if (newLoginMode === "google") {
            stockClient.handleLogout();
        }
        else if (newLoginMode === "bypass") {
            ssoClient.logout();
        }
    }
}
